// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.evaluation-card .card-header {\n  padding: 0.4rem 16px;\n  border-radius: 10px;\n  background: #F2F2F2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.evaluation-card .card-header-title,\n.evaluation-card .card-header-icon {\n  padding: 0;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4D4D4D;\n}\n", ""]);
// Exports
module.exports = exports;
